var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIveysvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 44,
    viewBox: "0 0 169 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.9544V43.9022H2.7069H5.41379V21.9544V0.00658408H2.7069H0V21.9544ZM28.4233 0.189482L28.4922 0.372381L35.7101 22.1373L42.9282 43.9022H46.3816H49.835L57.0512 22.1424L64.2673 0.382623L64.3408 0.191238L64.4141 0L61.6602 0.0399443L58.9065 0.0797434L52.7545 19.2719L46.6025 38.4641L46.5184 38.5483L46.4341 38.6324L40.1535 19.3215L33.8728 0.010681L31.1137 0.00863253L28.3545 0.00658408L28.4233 0.189482ZM87.3523 2.494V4.98142H100.814H114.275V2.494V0.00658408H100.814H87.3523V2.494ZM141.915 13.9726L148.952 27.9445V35.9234V43.9022H151.659H154.366V36.0007V28.0992L161.39 14.0529L168.413 0.00658408H165.422H162.432L157.822 9.11493L153.212 18.2233L152.418 19.7362L151.625 21.2491L146.292 10.6644L140.96 0.0797434L137.919 0.0400905L134.879 0.000584953L141.915 13.9726ZM87.3523 31.4651V43.9022H101.106H114.86V41.4148V38.9274H103.813H92.7661V31.392V23.8565H102.716H112.665V21.4423V19.028H100.009H87.3523V31.4651Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIveysvg);
export default __webpack_public_path__ + "static/media/iveysvg.c4873c947a5164d2d803efc69e18cb1d.svg";
export { ForwardRef as ReactComponent };